const STORAGE_KEYS = {
    ALL_TEAMS: 'allTeams',
    AUTH_TOKEN: 'authToken',
    ACTIVE_TEAM: 'activeTeam'
};

// Helper function to clean token
const cleanToken = (token) => {
    if (!token) return null;
    return token.replace(/^Bearer\s+/i, '');
};

export const authService = {
    login: async (credentials) => {
        try {
            const response = await fetch(process.env.REACT_APP_AUTH_ENDPOINT, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                credentials: 'include',
                body: JSON.stringify({
                    username: credentials.username,
                    password: credentials.password
                })
            });
            const data = await response.json();
            if (data.status === 200 && data.response) {
                // Store auth token in localStorage
                const cleanAuthToken = cleanToken(data.response.token);
                localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, cleanAuthToken);
                // Store the first team as active team in localStorage
                if (data.response.teamDetails && data.response.teamDetails.length > 0) {
                    localStorage.setItem(STORAGE_KEYS.ACTIVE_TEAM, JSON.stringify(data.response.teamDetails[0]));
                    // Store all teams in localStorage
                    localStorage.setItem(STORAGE_KEYS.ALL_TEAMS, JSON.stringify(data.response.teamDetails));
                }
                return { status: 200, data };
            }
            return { 
                status: response.status, 
                data: { message: data.message || 'Authentication failed' } 
            };
        } catch (error) {
            return { 
                status: 500, 
                data: { message: 'An error occurred during authentication' } 
            };
        }
    },

    logout: () => {
        localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
        localStorage.removeItem(STORAGE_KEYS.ACTIVE_TEAM);
        localStorage.removeItem(STORAGE_KEYS.ALL_TEAMS);
    },

    isAuthenticated: () => {
        return !!localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
    },

    getAuthToken: () => {
        const token = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
        return token ? `Bearer ${token}` : null;
    },

    getActiveTeam: () => {
        const team = localStorage.getItem(STORAGE_KEYS.ACTIVE_TEAM);
        return team ? JSON.parse(team) : null;
    },

    getAllTeams: () => {
        const teams = localStorage.getItem(STORAGE_KEYS.ALL_TEAMS);
        return teams ? JSON.parse(teams) : [];
    }
}; 